import type { CharacterRow } from '../../../lib/types';
import type { DraftChild } from './types';

const isComingWithCharacter = (
  c: DraftChild,
): c is DraftChild & { character_id: number } =>
  c.status === 'coming' && c.character_id !== null;

export const lockedCharacterIds = (children: DraftChild[]): Set<number> =>
  new Set(children.filter(isComingWithCharacter).map((c) => c.character_id));

export const withAvailability = (
  characters: CharacterRow[],
  locked: Set<number>,
  exceptId: number | null,
): CharacterRow[] =>
  characters.map((c) =>
    locked.has(c.id) && c.id !== exceptId ? { ...c, taken: 1 } : c,
  );

export const findById = (characters: CharacterRow[], id: number | null): CharacterRow | null =>
  id == null ? null : characters.find((c) => c.id === id) ?? null;

export const groupByFighter = (
  characters: CharacterRow[],
): Map<string, CharacterRow[]> => {
  const map = new Map<string, CharacterRow[]>();
  for (const char of characters) {
    if (!map.has(char.name)) {
      map.set(char.name, []);
    }
    map.get(char.name)!.push(char);
  }
  return map;
};
